module.exports = __webpack_public_path__ + "static/img/penny_pictgrid16_980x856.731f237.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/penny_pictgrid16_980x856.jpg
// module id = M6Md
// module chunks = 0